import { render, staticRenderFns } from "./LECO_UserRegistConfirmation.vue?vue&type=template&id=0b929a8a&"
import script from "./LECO_UserRegistConfirmation.vue?vue&type=script&lang=js&"
export * from "./LECO_UserRegistConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports